module.exports = __webpack_public_path__ + "static/media/different-equation-bg-2.8d4aef7a.png";